"use strict";

define('rs/models/report',['rs/models/abstract', 'rs/models/person'], function (AbstractModel, Person) {
  var ReportModel = AbstractModel.extend({
    properties: ['author', 'activityDate', 'data', 'id', 'lastRunDate', 'createDate', 'modifiedDate', 'name', 'type', 'updateUserAuthId', 'version'],
    create: function create() {
      return this.constructor.requestCreateReport(this).bind(this).then(function (model) {
        this.updateWith(model);
      });
    },
    update: function update(data) {
      this.applyProperties(data);
      return this.constructor.requestUpdateReport(this).bind(this).then(function (model) {
        this.updateWith(model);
      });
    },
    toJSON: function toJSON() {
      var properties = this._super.apply(this, arguments);
      properties.data = JSON.stringify(properties.data);
      if (properties.author) {
        properties.author = {
          id: properties.author.id
        };
      }
      return properties;
    }
  }, {
    rootURI: '/rs/api/',
    parsers: {
      '#GET#report': function GETReport(data) {
        return ReportModel.models(data);
      },
      '#GET#report/:id': function GETReport_Id(data) {
        return ReportModel.model(data);
      },
      '#POST#report': function POSTReport(data) {
        return ReportModel.model(data);
      },
      '#PUT#report/:id': function PUTReport_Id(data) {
        return ReportModel.model(data);
      }
    },
    model: function model(data) {
      if (data.author) {
        data.author = Person.model(data.author);
      }
      if (data.data) {
        data.data = JSON.parse(data.data);
      }
      return new this(data);
    },
    getCsvURL: function getCsvURL(report) {
      return '/rs/api/report/' + report.id + '/result';
    },
    requestCreateReport: function requestCreateReport(data) {
      return this.post('report', data, {
        jsonBody: true
      });
    },
    requestDeleteReport: function requestDeleteReport(reportId) {
      return this.del('report/' + reportId);
    },
    requestReport: function requestReport(reportId) {
      return this.get('report/' + reportId);
    },
    requestReports: function requestReports(reportTypeId) {
      var params = {
        q: reportTypeId
      };
      return this.get('report', params);
    },
    requestReportTypes: function requestReportTypes() {
      return this.get('type/report');
    },
    requestReportColumns: function requestReportColumns(reportTypeId) {
      return this.get('report/' + reportTypeId + '/columns');
    },
    requestUpdateReport: function requestUpdateReport(report) {
      return this.put('report/' + report.id, report, {
        jsonBody: true
      });
    },
    requestReportResults: function requestReportResults(reportId) {
      return this.get('report/' + reportId + '/result');
    },
    requestReportDefinitionResults: function requestReportDefinitionResults(reportDefinition) {
      return this.post('report/result', reportDefinition, {
        jsonBody: true
      });
    }
  });
  return ReportModel;
});

